/* eslint-disable */
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { t } from "i18next";
import React from "react";
import { Link } from "react-router-dom";

const EventProductsHeader = ({
  isEventModerator,
  changeStatusHandler,
  reloadList,
  resetAll = () => {},
  breadCrumbText = [],
}) => {
  return (
    <div className="bg-white mt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb
            breadCrumbText={breadCrumbText}
            displayName={t("Event Products")}
            top={false}
          />
        </div>

        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* ------ refresh icon start ------ */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* ------ refresh icon end ------ */}

          {/* --- action section start --- */}
          {isEventModerator ? (
            <div className="dropdown flex-fill flex-grow-sm-0">
              <button
                className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="fw-semibold small">{t("Action")}</span>
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              </button>
              <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
                {/* --- add label start --- */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    data-bs-toggle="modal"
                    data-bs-target="#addLabelModal"
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      label
                    </span>
                    <span className="d-block">{t("Add Label")}</span>
                  </Link>
                </li>
                {/* --- add label start --- */}

                {/* --- delete start --- */}
                <li>
                  <Link
                    to="#"
                    className="dropdown-item d-flex align-items-center gap-2 py-2 text-danger"
                    onClick={changeStatusHandler}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      delete
                    </span>
                    <span className="d-block">{t("Delete")}</span>
                  </Link>
                </li>
                {/* --- delete end --- */}
              </ul>
            </div>
          ) : null}
          {/* --- action section end --- */}

          {/* --- add new product start --- */}
          {isEventModerator ? (
            <Link
              to="#"
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
              dtype="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasEventProduct"
              aria-controls="offcanvasEventProduct"
              onClick={resetAll}
            >
              <span className="d-block material-symbols-outlined icon-md">
                add
              </span>
              <span className="d-block">{t("Add New")}</span>
            </Link>
          ) : null}
          {/* --- add new product end --- */}
        </div>
      </div>
    </div>
  );
};

export default EventProductsHeader;
